"use client";

import { SidebarProvider } from "@oreme/ui";
import { Provider as StoreProvider } from "jotai";
import { useLocale } from "next-intl";
import React, { PropsWithChildren } from "react";
import { createDevicesStore } from "@/store/devices";
import type { Observatory, Tag } from "@/types";

interface DevicesProviderProps extends PropsWithChildren {
  observatories: Observatory[];
  tags: Tag[];
}

function DevicesProvider({
  observatories,
  tags,
  children,
}: Readonly<DevicesProviderProps>) {
  const locale = useLocale();
  const store = createDevicesStore(observatories, tags, locale);
  return (
    <StoreProvider store={store}>
      <SidebarProvider className="min-h-[calc(100svh-var(--globalnav-height))]">
        {children}
      </SidebarProvider>
    </StoreProvider>
  );
}

export { DevicesProvider, type DevicesProviderProps };
